<div class="key-point">
  <div class="key-point__text" [ngClass]="keyPointClass">
    <div>{{ text }}</div>
    <div *ngIf="price">{{ price }}</div>
  </div>
  <div *ngIf="additionalText" class="key-point__additional-text">{{ additionalText }}</div>
</div>
